<template>
  <div class="w-full  rounded-lg pointer-events-auto">
    <div class=" flex " :class="{ 'border-t border-green': index !== 0 }">
      <div class="w-0 flex-1 p-4">
        <submission-spinner v-if="showSpinner"></submission-spinner>
        <div v-else class="flex items-start">
          <div>
            <avatar :user-display="comment.userDisplay"></avatar>
            <div class="flex items-center" v-if="isAdmin">
              <button
                @click="openModal"
                class=" p-1 rounded-full  relative mt-2 mx-auto focus:outline-none"
              >
                <svg
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="text-peach fill-current w-6 h-6 hover:text-darkpurple"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div class="ml-3 w-0 flex-1">
            <p class="text-sm leading-5 font-medium text-gray-700">
              {{ comment.userDisplay }}
            </p>
            <vue-markdown :source="comment.body" class="mt-2 text-md leading-5 text-gray-900"></vue-markdown>
          </div>
        </div>
        <confirmation-modal
                v-if="modal"
                :message="comment"
                @confirm="removeComment"
                @cancel="closeModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "./Avatar";
import SubmissionSpinner from "./SubmissionSpinner";
import ConfirmationModal from "./ConfirmationModal";
import VueMarkdown from "vue-markdown";

import { mapGetters } from "vuex";
export default {
  name: "Comment",
  components: { Avatar, SubmissionSpinner, ConfirmationModal, VueMarkdown },
  props: {
    comment: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "deletedMessageID"]),
    initial() {
      return this.comment.userDisplay.charAt(0);
    },
    showSpinner() {
      if (this.deletedMessageID === this.comment.id) {
        return true;
      }
      return false;
    }
  },
  methods: {
    removeComment() {
      this.$emit("remove-comment", this.comment.id);
      this.modal = false;
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    }
  }
};
</script>

<style scoped></style>
